import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { RoutePresetControllerService, RoutePresetDto } from '@api/core';
import { tapResponse } from '@ngrx/operators';
import { patchState, signalStoreFeature, type, withMethods, withProps, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { NotificationService } from '@shared/services/notifications/notifications.service';
import { pipe, switchMap } from 'rxjs';

export const useRoutePresets = () =>
  signalStoreFeature(
    {
      props: {
        _notificationService: type<NotificationService>(),
      },
    },
    withState({
      routePresets: new Array<RoutePresetDto>(),
    }),
    withProps(() => ({
      _routePresetsService: inject(RoutePresetControllerService),
    })),
    withMethods(store => {
      const loadRoutePresets = rxMethod<void>(
        pipe(
          switchMap(() =>
            store._routePresetsService.getRoutePresets().pipe(
              tapResponse({
                next: (routePresets: RoutePresetDto[]) => patchState(store, { routePresets }),
                error: (error: HttpErrorResponse) =>
                  store._notificationService.showErrorNotification('Failed to load route presets', error),
              }),
            ),
          ),
        ),
      );
      return { loadRoutePresets };
    }),
  );
